import React, { useMemo } from "react";

import { noop } from "lodash";

import ItemGroupWrapper from "./styled-components";
import Item from "../../_atom/RGItem";

const ItemGroup = ({
  indexSelected,
  indexSelectedUpdate,
  indexesApplied,
  items,
  isSimplified,
  className
}) =>
  useMemo(
    () => (
      <ItemGroupWrapper className={className} data-qa-label="rg-item-group">
        {items.map((item, idx) => (
          <Item
            qaLabel={`rg-item-group-item-${item.id}`}
            key={item.id}
            title={item.title}
            description={item.description}
            isActive={idx === indexSelected}
            isApplied={indexesApplied.includes(idx)}
            icon={item.icon}
            promptClick={() => indexSelectedUpdate(idx)}
            isSimplified={isSimplified}
          />
        ))}
      </ItemGroupWrapper>
    ),
    [
      indexSelected,
      indexSelectedUpdate,
      JSON.stringify(items),
      JSON.stringify(indexesApplied)
    ]
  );

ItemGroup.defaultProps = {
  indexSelected: 0,
  indexSelectedUpdate: noop,
  indexesApplied: [],
  items: [],
  isSimplified: false,
  className: ""
};

export default ItemGroup;
